import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { AccountService } from '@app/core/services/account.service';
import { EffectsModule } from '@ngrx/effects';
import { ActionReducer, MetaReducer, StoreModule } from '@ngrx/store';
import { LoadInterceptor } from './interceptors/load-interceptor';
import { TokenInterceptor } from './interceptors/token-interceptor';
import { AdminService } from './services/admin.service';
import { AuthService } from './services/auth.service';
import { ConfigService } from './services/config.service';
import { LoadService } from './services/load.service';
import { NotificationsService } from './services/notifications.service';
import { OrdersService } from './services/orders.service';
import { OrganizationsService } from './services/organizations.service';
import { ResultsService } from './services/results.service';
import { SideBarNotificationService } from './services/side-bar-notification.service';
import { UsersService } from './services/users.service';
import { AdminEffects } from './store/effects/admin.effects';
import { NotificationsEffects } from './store/effects/notifications.effects';
import { OrderEffects } from './store/effects/order.effects';
import { OrganizationEffects } from './store/effects/organization.effects';
import { ResultsEffects } from './store/effects/results.effects';
import { SideBarNotificationEffects } from './store/effects/side-bar-notification.effect';
import { UserEffects } from './store/effects/user.effects';
import { REDUCER_TOKEN } from './store/reducers';

export function debug(reducer: ActionReducer<any>): ActionReducer<any> {
  return function (state, action) {
    return reducer(state, action);
  };
}

export const metaReducers: MetaReducer<any>[] = [debug];

@NgModule({
  imports: [
    StoreModule.forRoot(REDUCER_TOKEN, {
      metaReducers,
      // runtimeChecks: {
      //   strictActionImmutability: true,
      //   strictActionSerializability: true,
      //   strictStateImmutability: true,
      //   strictStateSerializability: true
      // }
    }),
    //  !environment.production ? StoreDevtoolsModule.instrument() : [],
    // StoreRouterConnectingModule.forRoot({stateKey:'router'}),
    EffectsModule.forRoot([
      AdminEffects,
      NotificationsEffects,
      OrderEffects,
      OrganizationEffects,
      UserEffects,
      ResultsEffects,
      SideBarNotificationEffects
    ]),
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: TokenInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: LoadInterceptor, multi: true },
    ConfigService,
    AccountService,
    AdminService,
    AuthService,
    NotificationsService,
    OrdersService,
    OrganizationsService,
    ResultsService,
    SideBarNotificationService,
    UsersService,
    LoadService
  ]
})
export class CoreModule { }
